<script>
  /* Executable code section of the program */
  //Tools importation
  import { temporalMeetInfo, isAttendeeMeetModalOn } from "../../apis/storage";

  //Auxiliary variables
  // Definition of the window witdh
  let windowSize = window.innerWidth;

  //function to undisplay modal
  const undisplayModal = () => {
    $isAttendeeMeetModalOn = false;
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        class="bi bi-x-lg icon"
        viewBox="0 0 16 16"
        on:click={undisplayModal}
        on:keypress={undisplayModal}
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
        />
      </svg>
    </div>
    <div class="bodyContent">
      <div class="headerContainer">
        {#if windowSize < 700}
        <h1>Meeting Information</h1>
        {:else}
        <h1>Meeting members</h1>
        {/if}
      </div>
      {#if windowSize < 700}
      <h2 class="infoTittle">Information</h2>
      <div class="infoMeetContainer">
        <p class="textInfo">
            <b>Break Tittle: </b>{$temporalMeetInfo.breakTittle} <br>
            <b>Time: </b>{$temporalMeetInfo.meetingTime.startTime} - {$temporalMeetInfo.meetingTime.endTime} <br>
            <b>Custom Table: </b>{$temporalMeetInfo.meetingCustomTable} <br>
            <b>Place: </b>{$temporalMeetInfo.placeBreak} <br>
        </p>
      </div>
      {/if}
      <div class="bodyInfoContainer">
        {#if windowSize < 700}
        <h2>Meeting members</h2>
        {/if}
        <div class="hostInfo">
            <h2>Host:</h2>
            <h5>{$temporalMeetInfo.host.name} {$temporalMeetInfo.host.surname}</h5>
            <p class="textInfo">
                {$temporalMeetInfo.host.jobtittle} <br>
                {$temporalMeetInfo.host.company} <br>
                {$temporalMeetInfo.host.country}
            </p>
        </div>
        <div class="invitedInfo">
            <h2>Invited:</h2>
            <h5>{$temporalMeetInfo.invitedAttendees[0].name} {$temporalMeetInfo.invitedAttendees[0].surname}</h5>
            <p class="textInfo">
                {$temporalMeetInfo.invitedAttendees[0].jobtittle} <br>
                {$temporalMeetInfo.invitedAttendees[0].company} <br>
                {$temporalMeetInfo.invitedAttendees[0].country}
            </p></div>
      </div>
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.514);
    display: flex;
    justify-content: center;
    padding: 30px;
  }
  /* Content styles */
  .contentContainer {
    overflow: auto;
    width: 50%;
    height: auto;
    max-height: 70vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  /* HeaderContent styles */
  .headerContent {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* Body Content */
  /* header */
  .bodyContent{
    width: 100%;
  }
  .headerContainer{
    width: 100%;
    border-bottom: 1px solid gray;
  }
  h1{
    padding: 15px;
  }
  /* Body */
  .bodyInfoContainer{
    width: 100%;
    padding: 10px;
    display: flex;
    margin: 10px 0;
  }
  .hostInfo,.invitedInfo{
    width: 50%;
    height: auto;
    padding: 20px 40px;
  }
  .hostInfo{
    border-right: 1px solid gray;
  }
  .textInfo{
    font-size: 20px;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
  /* Content styles */
  .contentContainer {
    overflow: auto;
    width: 80%;
    height: auto;
    max-height: 40vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Principal container styles */
    .principalContainer{
        padding: 5px;
    }
  /* Content styles */
  .contentContainer {
    overflow: auto;
    width: 100%;
    height: auto;
    max-height: 90vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
  /* Body */
  .infoMeetContainer{
    width: 100%;
    padding: 20px 30px;
  }
  .bodyInfoContainer{
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
  }
  .infoTittle{
    padding: 10px 20px;
  }
  .hostInfo,.invitedInfo{
    width: 100%;
    height: auto;
    padding: 20px;
  }
  .hostInfo{
    border-right: 0;
    border-bottom: 1px solid gray;
  }
  .textInfo{
    font-size: 20px;
  }
  }
  /* End of the section */
</style>
